import RankingNavigation from './RankingNavigation';

export default RankingNavigation;
